const constants = {
  searchPlaceholder: "Buscar negocio...",
  createUser: "Crear usuario",
};

export default constants;
